/** Core chain (1116) LST read surface.
 *
 *  - stCORE: the rate lives on the `Earn` contract (`stCORE.earn()`),
 *    `getCurrentExchangeRate()` — **1e6-scaled** CORE-per-stCORE
 *    (verified ≈ 1262019 ≈ 1.262), NOT 1e18.
 *  - SCORE / dualCORE: value-accruing share tokens whose backing is
 *    `totalStaked()` (on the token itself for SCORE, on the b14g
 *    `coreVault()` for dualCORE) over the share `totalSupply()`. */
export const CoreEarnRateAbi = [
  {
    name: 'getCurrentExchangeRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const

export const CoreTotalStakedAbi = [
  {
    name: 'totalStaked',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
